import { API } from '../../utils/amplifyWrapper';
import { useQuery } from "@tanstack/react-query";
import { getGa4Attribution } from '../../utils/Ga4Client';

export const fetchOrganisation = async (org_id: string) => {
    // GROW-80 backfill: orgs that signed up before ga_client_id capture shipped
    // never got one stored — resend it here so the API can fill the gap on any
    // authenticated load. No-ops server-side once the org already has one.
    const response = await API.get('main', `/organisation/${org_id}`, {headers: {'Content-Type': "application/json"}, queryStringParameters: getGa4Attribution()});
    return response.data; // Extract data here
}

export const fetchOrganisationUsage = async (org_id: string) => {
    const response = await API.get('main', `/organisation/${org_id}/usage`, {headers: {'Content-Type': "application/json"}});
    return response.data; // Extract data here
}

interface IuseOrganisationProps {
    org_id: string
}

export const useOrganisation = ({org_id}: IuseOrganisationProps) => {
    return useQuery(['organisation', org_id], () => fetchOrganisation(org_id), {
        enabled: !!org_id
    })
}

export const useOrganisationUsage = ({org_id}: IuseOrganisationProps) => {
    return useQuery(['organisation_usage', org_id], () => fetchOrganisationUsage(org_id), {
        enabled: !!org_id
    })
}
